import { OnboardingPaywallModalCallable } from "@components/OnboardingWizard/Paywall/OnboardingPaywallModalCallable";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";
import {
  ACCOUNTS_RECONNECT_PAYWALL_COPY_OVERRIDES,
  ACCOUNTS_RECONNECT_PAYWALL_TRACKING_MODULE,
  GOAL_ACTIVATE_PAYWALL_COPY_OVERRIDES,
  GOAL_ACTIVATE_PAYWALL_TRACKING_MODULE,
  ONBOARDING_PAYWALL_COPY_OVERRIDES,
  ONBOARDING_PAYWALL_TRACKING_MODULE,
} from "./constants/onboardingPaywallCopy";
import { ONBOARDING_PAYWALL_MODAL_Z_INDEX } from "@components/OnboardingWizard/PlanOverviewModal/planOverviewModalShell";
import type { OnboardingPaywallOutcome } from "@/src/hooks/onboarding/onboardingV3Types";

type OnboardingPaywallVariant =
  "onboarding_first" | "goal_activate_second" | "accounts_reconnect";

export interface OpenOnboardingPaywallOptions {
  onClose?: () => void;
  paywallVariant?: OnboardingPaywallVariant;
  /** 覆盖 Paywall analytics source（如 tracker / goal_activate） */
  analyticsSource?: string;
  /** User clicked web pay CTA and got redirected to pricing. */
  onWebCheckoutRedirect?: () => void;
}

const resolvePaywallVariantConfig = (variant: OnboardingPaywallVariant) => {
  if (variant === "goal_activate_second") {
    return {
      trackingModuleName: GOAL_ACTIVATE_PAYWALL_TRACKING_MODULE,
      paywallCopyOverrides: GOAL_ACTIVATE_PAYWALL_COPY_OVERRIDES,
      defaultAnalyticsSource: "goal_activate",
    };
  }
  if (variant === "accounts_reconnect") {
    return {
      trackingModuleName: ACCOUNTS_RECONNECT_PAYWALL_TRACKING_MODULE,
      paywallCopyOverrides: ACCOUNTS_RECONNECT_PAYWALL_COPY_OVERRIDES,
      defaultAnalyticsSource: "accounts_reconnect",
    };
  }
  return {
    trackingModuleName: ONBOARDING_PAYWALL_TRACKING_MODULE,
    paywallCopyOverrides: ONBOARDING_PAYWALL_COPY_OVERRIDES,
    defaultAnalyticsSource: "onboarding",
  };
};

/** 免费用户订阅 Paywall；`purchased` = 支付成功 */
export const openOnboardingPaywall = async (
  isPC: boolean,
  options?: OpenOnboardingPaywallOptions,
): Promise<OnboardingPaywallOutcome> => {
  const variant = options?.paywallVariant ?? "onboarding_first";
  const config = resolvePaywallVariantConfig(variant);
  const analyticsSource =
    options?.analyticsSource ?? config.defaultAnalyticsSource;

  return callEdgenModalWhenRootReadyAsync(async () => {
    const result = await OnboardingPaywallModalCallable({
      isPC,
      trackingModuleName: config.trackingModuleName,
      paywallCopyOverrides: config.paywallCopyOverrides,
      analyticsSource,
      zIndex: ONBOARDING_PAYWALL_MODAL_Z_INDEX,
      onClose: options?.onClose,
      onWebCheckoutRedirect: options?.onWebCheckoutRedirect,
    });

    return result === true ? "purchased" : "dismissed";
  });
};
